import { render } from "./teaWorkAgeEchart.vue?vue&type=template&id=d9774e10&scoped=true"
import script from "./teaWorkAgeEchart.vue?vue&type=script&lang=js"
export * from "./teaWorkAgeEchart.vue?vue&type=script&lang=js"

import "./teaWorkAgeEchart.vue?vue&type=style&index=0&id=d9774e10&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9774e10"]])

export default __exports__